import React from "react";
import Routes from "./Routes";
import DevToolsProtection from "./components/DevToolsProtection";

function App() {
  return (
    <>
      <DevToolsProtection />
      <Routes />
    </>
  );
}

export default App;
